import React from 'react';
import { Radar } from 'lucide-react';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '../ui/dialog';
import CasoInvestigar from './CasoInvestigar';

// E3/F6: "Investigar" pasa a ser un botón de la barra de acciones (antes era una pestaña).
export const CasoInvestigarDialog = ({ open, onOpenChange, ...props }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[90vh] max-w-5xl overflow-y-auto bg-white" data-testid="caso-investigar-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><Radar size={18} className="text-indigo-600" /> Investigar</DialogTitle>
        <DialogDescription>Corré monitores sobre este cliente y agregá las coincidencias al caso.</DialogDescription>
      </DialogHeader>
      <CasoInvestigar {...props} />
    </DialogContent>
  </Dialog>
);

export default CasoInvestigarDialog;
